export default __webpack_public_path__ + "static/media/home-foto-testimonios-viajes-profile-tower-Incoming-desk-1.57102134.jpg";